import { Skeleton } from "@/components/skeleton";

const ROWS: { own: boolean; width: string }[] = [
  { own: false, width: "w-3/5" },
  { own: true, width: "w-2/5" },
  { own: false, width: "w-4/5" },
  { own: true, width: "w-1/2" },
  { own: false, width: "w-2/3" },
  { own: true, width: "w-1/3" },
];

export function ChatSkeleton() {
  return (
    <div className="flex w-full flex-col gap-[20px]">
      {ROWS.map((row, index) => (
        <div
          className={`flex items-end gap-2 ${row.own ? "flex-row-reverse" : ""}`}
          key={index}
        >
          <Skeleton className="h-8 w-8 shrink-0 rounded-full" />
          <Skeleton className={`h-16 rounded-xl ${row.width}`} />
        </div>
      ))}
    </div>
  );
}
